import { h } from 'preact'
import Key from '../assets/key'
import MethodBox from './MethodBox'
import ButtonControl from '../button-control'

interface Props {
    onSAMLInstall: () => void
}

const MethodBoxSAML = ({ onSAMLInstall }: Props) =>
  <MethodBox>
    <Key />
    <div className='method-saml-2'>SAML 2</div>
    <ButtonControl
      title='Install'
      variant='primary'
      onClick={() => onSAMLInstall()}
      class='sso-overview__saml-install'
    />
  </MethodBox>

export default MethodBoxSAML
